import React from "react";
import { Link } from "react-router-dom";
export default function Navbar(props) {
  return (
    <nav style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
      <Link to="/">Home</Link>
      <Link to="/about">About</Link>
      <Link to="/cart">Cart({props.data?.cart?.items?.length || 0})</Link>
    </nav>
  );
}
